import BaseView from 'components-framework/view/base.view';

export const MembershipHotelBannerView = BaseView.extend({
    events: {
    },
    selectors: {
    },
    initialize() {
        this.renderTemplate();
    },
    renderTemplate() {
        const template = this.templates.main({
            keys: this.keys,
        });
        this.$el.html(template);
    },
});
